/**
 * lazy 라우트가 초기 진입에서 해석되는 동안 보여줄 화면.
 * 없으면 react-router 가 null 을 렌더하며 경고를 남긴다(HydrateFallback 미제공).
 *
 * `mainRoutes.tsx` 에서 분리한 이유: 그 파일은 컴포넌트가 아닌 값(`mainRoutes`)을
 * export 하는데, 같은 파일에 컴포넌트가 함께 있으면 Fast Refresh 가 깨진다
 * (react-refresh/only-export-components).
 */
export function RouterHydrateFallback() {
  return <div className="min-h-screen" aria-busy="true" />;
}
